<template>
    <div>
        <div style=""></div>
        <div class="u-hd">
            <div class="hd-bk" @click="closeModle">
                <i class="icon iconback" ></i>&nbsp;返回
            </div>
            <div class="hd-tl">客户订货单列表</div>
            <div class="hd-mu">
            </div>
        </div>
        <div style="height:44px"></div>
        <div class="search">
            <div class="search-lst">
                <div class="search-lst-tag">
                    <div class="icon icondingdanhao"></div>
                    <div class="lst-tag-vle">
                        <input 
                        style="height:28px;border:0px solid #ccc;line-height:28px;" 
                        placeholder-class="placeholder"
                            v-model="input" placeholder="请输入单据号" />
                    </div>
                </div>
                <div class="search-lst-tag" @click="$refs.selectTime.open()">
                    <div class="icon iconriqi"></div>
                    <div class="lst-tag-vle">
                        <div v-if="tabType=='0'">今日</div>
                        <div v-if="tabType=='1'">昨日</div>
                        <div v-if="tabType=='5'">前日</div>
                        <div v-if="tabType=='2'">近一周</div>
                        <div v-if="tabType=='3'">近一月</div>
                        <div v-if="tabType=='4'">自定义日期</div>
                    </div>
                </div>
            </div>
            <div class="search-lst">
                <div class="search-lst-tag" @click="$refs.selectPick.open()">
                    <div class="lst-tag-vle">
                        <div class="placeholder" v-if="!orderType.key">请选择单据状态</div>
                        <div v-else>{{orderType.text}}</div>
                    </div>
                </div>
                <div class="search-lst-tag" @click="$refs.selectMerchantPick.open()" v-if="$store.state.supplierInfo.businessType=='0'">
                    <div class="lst-tag-vle">
                        <div class="placeholder" v-if="!merchant.id">请选择组织机构</div>
                        <div v-else>{{merchant.name}}</div>
                    </div>
                </div>
                <div class="search-lst-tag" v-else>
                    {{$store.state.supplierInfo.name}}
                </div>
            </div>
            <div class="search-lst">
                <div style="flex:1"></div>
                <div class="search-lst-tag" style="border-bottom:0px;">
                    <div class="search-btn-group">
                        <div class="search-btn" @click="goSearch">
                            <div class="icon iconsousuo"></div>
                            <div style="padding-left:10px;">查询</div>
                        </div>
                        <div style="width:1px;height:20px;background:#bbb"></div>
                        <div class="search-btn" @click="clearSearch">
                            <div class="icon iconzhongzhi"></div>
                            <div style="padding-left:10px;">重置</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list">
            <van-empty v-if="!list || list.length<=0">
                <template slot="image">
                    <div style="text-align:center;margin-top:50px">
                        <i class="icon iconzanwushuju2" style="font-size:50px;color:#CCC"></i>
                    </div>
                    <div style="color:#CCC;text-align:center">暂无数据</div>
                </template>
            </van-empty>
            <mu-load-more @refresh="refresh" :loaded-all="isAllData" :refreshing="refreshing" :loading="loading" @load="load">
                <div class="ct-order" v-for="(item,index) in list" :key="item.id">
                    <div class="order-item">
                        <div class="item-icon">
                            <i class="icon icondanju" style="font-size: 25px;color:#4C37B6"></i>
                        </div>
                    </div>
                    <div class="order-box">
                        <div class="box-tl" style="display:flex;border-bottom: 1px solid #e8e8e8;">
                            <div style="width:calc(100% - 100px)">{{item.no}}</div>
                            <div style="width:100px;text-align:right;padding-right:15px;font-weight:500">
                                <span style="color:#ff862a" v-if="item.sendState=='0'">未处理</span>
                                <span style="color:#8bc34a" v-else>已处理</span>
                            </div>
                        </div>
                        <div style="display:flex">
                            <div class="box-text" style="flex:1">订货机构：<span style="color:#333">{{item.merchantName}}</span></div>
                        </div>
                        <div style="display:flex">
                            <div class="box-text" style="flex:1">单据金额：<span style="color:#333">{{item.amount?item.amount.toFixed(2):0.00}}</span></div>
                        </div>
                        <div style="display:flex">
                            <div class="box-text" style="flex:1">单据数量：<span style="color:#333">{{item.stockCount?item.stockCount.toFixed(2):0.00}}</span></div>
                        </div>
                        <div style="display:flex;align-items: center;">
                            <div class="box-text" style="flex:1">
                                制单日期：<span style="color:#333">{{item.operatorTime}}</span>
                            </div>
                            <div style="color:#333;margin-right:10px;width:100px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{item.operatorName}}</div>
                        </div>
                        <div class="box-btns" style="display:flex;align-items:center">
                            <div style="width:150px;text-align:left;font-size:15px;font-weight:600;color:#4C37B6">{{moment(item.operatorTime).format("YYYY-MM-DD")}}</div>
                            <div style="flex:1">
                                <span class="btns-item" decode="true" @click="goDetailShow(item.id,item)" ><i class="icon icongengduo3"></i>&nbsp;查看详情</span>
                            </div>
                        </div>
                    </div>
                </div>
            </mu-load-more>
        </div>
        <select-merchant ref="selectMerchantPick" title="选择组织机构" :item.sync="merchant"></select-merchant>
        <select-time ref="selectTime" :type.sync="tabType" :typeText.sync="tabText" :st.sync="startTime" :et.sync="endTime"></select-time>
        <select-pick ref="selectPick" title="选择单据状态" :datas="options" :value-key="'key'" :label="'text'" :item.sync="orderType" ></select-pick>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            tabType:'2',
            tabText:'近一周',
            options:[
                {
                    key:'1',
                    text:'未处理',
                },
                {
                    key:'2',
                    text:'已处理',
                }
            ],
            startTime: '',
            endTime: '',
            maxDate: new Date(),
            currentPage:1,
            input:'',
            merchant:{},
            orderType:{key:'',text:''},
            list:[],
            refreshing: false,
            loading: false,
            isAllData:false,
        };
    },
    mounted() {
        this.startTime=this.moment().subtract(7, 'days').format("YYYY-MM-DD")
        this.endTime=this.moment().format("YYYY-MM-DD")
        this.merchant=this.$store.state.supplierInfo.defOrg?this.$store.state.supplierInfo.defOrg:{}
        this.getData()
    },
    methods: {
        changeTabType(type) {
            this.tabType=type
            let startTime=''
            let endTime=''
            if (type == '0') {
                this.tabText='今日'
                startTime = this.moment().format("YYYY-MM-DD");
                endTime = this.moment().format("YYYY-MM-DD");
            } else if (type == '1') {
                this.tabText='昨日'
                startTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
                endTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
            } else if (type == '2') {
                this.tabText='近一周'
                startTime = this.moment().subtract(7, 'days').format("YYYY-MM-DD")
                endTime = this.moment().format("YYYY-MM-DD")
            } else if (type == '3') {
                this.tabText='近一月'
                endTime = this.moment().format("YYYY-MM-DD")
                startTime = this.moment().format("YYYY-MM-01")
            } else if (type == '4') {
                this.tabText='自定义数据'
                endTime = new Date(this.moment().format("YYYY-MM-DD"))
                startTime = new Date(this.moment().format("YYYY-MM-01"))
            }
            this.currentPage=1
            this.startTime=startTime
            this.endTime=endTime
            this.getData()
        },
        refresh () {
            this.refreshing = true;
            this.currentPage=1
            this.getData()
        },
        load () {
            this.loading = true;
            this.currentPage++;
            this.getData()
        },
        closeModle(){
            this.router.go(-1)
        },
        goDetailShow(id,item){
            if(item.type=='FOCUS_ORDER'){
                this.router.push({path:'/purchaseDetailFocus',query:{orderId:id}})
            }else{
                this.router.push({path:'/purchaseDetail',query:{orderId:id}})
            }
        },
        clearSearch(){
            this.input=''
            this.orderType={key:'',text:''}
            this.startTime=this.moment().subtract(7, 'days').format("YYYY-MM-DD")
            this.endTime=this.moment().format("YYYY-MM-DD")
            this.tabType='2'
            this.merchant={}
            this.tabText="近一周"
            this.getData()
        },
        goSearch(){
            this.refreshing=true
            this.currentPage=1
            this.getData()
        },
        getData(){
            this.$request.get("purchaseOrder/queryList?pageNum="+this.currentPage+"&pageSize="+10+"&startTime="+this.startTime+"&endTime="+this.endTime+"&state="+this.orderType.key+"&keyword="+this.input+"&merchantId="+(this.merchant.id?this.merchant.id:'')).then(data=>{
                if(this.loading){
                   this.loading = false;
                   this.isAllData=false
                }
                if(this.refreshing){
                    this.refreshing = false;
                }
                if(data.status==200){
                    
                    if(this.currentPage<2){
                        this.list=data.content.content
                    }else{
                        this.list=this.list.concat(data.content.content)
                    }
                    if(this.currentPage>data.content.totalPages){
                        this.isAllData=true
                        Toast.success('数据加载完毕');
                        return;
                    }
                }
            })
        },
    },
};
</script>

<style scoped>
     .search{ 
        margin:10px 10px;
        /* border-radius: 10rpx; */
        padding:0px 15px 10px 15px;
        background: #FFF;
    }
        /* list搜索box每行样式 */
    .search-lst{
        display:flex;
        justify-content:space-between
    }
    /* list搜索框样式 */
    .search-lst-tag{
        width:48%;
        height:40px;
        line-height: 40px;
        padding-top:5px;
        display: flex;
        border-bottom:1px solid #eee
    }
        /* 搜索框图标样式 */
    .search-lst-tag .icon{
        font-size:18px;
        color:#aaa
    }
        /* 搜索框内容样式 */
    .lst-tag-vle{
        flex:1;
        text-align:center;
        color:#666;
        font-size:13px;
    }
    /* 搜索框未选中样式 */
    .lst-tag-vle .placeholder{
        color:#adadad;
        font-size:13px;
        text-align: left;
    }
        /* 搜索框按钮Box */
    .search-btn-group{
        width:100%;
        display:flex;
        border-radius:8rpx;
        background:#777;
        display:flex;
        align-items:center;
        justify-content:space-between
    }
        /* 搜索框按钮样式 */
    .search-btn{
        color:#fff;
        display:flex;
        width:49%;
        justify-content:center;
        font-size:14px;
    }
    .list{
        height: calc(100vh - 195px);
        overflow-y: auto;
        padding:0px 10px
    }
    .list .list-item{
        display: flex;
        background: #FFF;
        padding: 10px;
        margin-bottom: 10px;
    }
    .list .list-item .item-icon{
        width: 50px;
        text-align: center;
    }
    .list .list-item .item-icon .icon{
        font-size: 30px;
        color: #486AD8;
    }
    .list .list-item .item-ct .ct-tl{
        color: #486AD8;
        padding: 10px 0px;
        font-size: 16px;
    }
    .list .list-item .item-ct .ct-val{
        color: #666;
        font-size: 13px;
    }
  .ct-order{
    display: flex;
    background-color: #FFF;
    padding: 5px 0px;
    margin-bottom: 10px;
  }
  .ct-order .order-item{
    width: 40px;
    text-align: center;
  }
  .ct-order .order-item .item-icon text{
    color:#888;
    font-size: 30px
  }
  .ct-order .order-box{
    width: calc(100% - 40px);
  }
  .ct-order .order-box .box-tl{
    font-size: 14px;
    font-weight: 600;
    padding:8px 0px
  }
  .ct-order .order-box .box-text{
    font-size: 13px;
    padding: 2px 0;
    color: #888;
  }
  .ct-order .order-box .box-btns{
    border-top: 1px solid #e8e8e8;
    margin-top: 5px;
    padding: 3px 0px;
    text-align: right;
  }
  .ct-order .order-box .btns-item{
    font-size: 14px;
    padding: 5px 10px;
    margin-right:5px;
    display: inline-block;
    color:#4c37b6
  }
  .ct-order .order-box .box-btn{
    margin-top: 5px;
    width: 90%;
    color: #FFF;
    background-color:#486AD8;
    border-radius: 5px;
    padding: 8px 0px;
    margin-bottom:10px;
    font-size: 14px;
    text-align: center;
  }
  .ct-order .order-box .box-btn span{
    color: #FFF;
  }
  .ct-order .order-box .box-btn .icon{
    font-size: 15px
  }
  .custom-image .van-empty__image {
    width: 90px;
    height: 90px;
  }
</style>


// WEBPACK FOOTER //
// src/views/purchaseOrder/list.vue